var content = require("!!../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[hash:base64:8]\"}!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/less-loader/dist/index.js!./style.less");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = require("!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/style-loader/dist?{"attributes":{}}!./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/tabs/style.less
// module id = 1226
// module chunks = 1